import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";

/**
 * `merchant_address.returnsCenterId` on the Return Mongo doc is `{ type: String }`
 * with no validator. Multiple writers populate it: some store the prefixed
 * display form (`rctr_…`) and some store the raw decimal of the underlying
 * `returns_center.id` bigint. Both shapes decode to the same id.
 *
 * Returns null for missing values and for strings matching neither shape.
 */
export function readReturnsCenterId(
  value: string | null | undefined,
): bigint | null {
  if (!value) {
    return null;
  }
  if (returnsCenterIdFormat.test(value)) {
    return returnsCenterIdFormat.read(value);
  }
  if (/^\d+$/.test(value)) {
    return BigInt(value);
  }
  return null;
}
